module.exports = __webpack_public_path__ + "img/blog_3.46bdb4b4.png";